import { render, staticRenderFns } from "./livreurs.vue?vue&type=template&id=0c85f4f2&scoped=true&"
import script from "./livreurs.vue?vue&type=script&lang=js&"
export * from "./livreurs.vue?vue&type=script&lang=js&"
import style0 from "./livreurs.vue?vue&type=style&index=0&lang=css&"
import style1 from "./livreurs.vue?vue&type=style&index=1&id=0c85f4f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c85f4f2",
  null
  
)

export default component.exports